import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseService } from "../../services/base.service";

export interface AuthoriseUrlResponse {
  authoriseUrl: string;
  state: string;
}

export interface AccountLinkResponse {
  accountLinkId: string;
  jdOrganisationId: string;
  jdOrganisationName: string;
  status: string;
  linkedAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class JohnDeereAuthService extends BaseService {

  private readonly baseUrl = this.API_ADMIN_BASE_URL + 'john-deere';

  constructor(private httpClient: HttpClient) {
    super();
  }

  getAuthoriseUrl(): Observable<AuthoriseUrlResponse> {
    return this.httpClient.get<AuthoriseUrlResponse>(`${this.baseUrl}/oauth/authorise-url`);
  }

  submitCallback(code: string, state: string, pgUserId: string): Observable<AccountLinkResponse> {
    return this.httpClient.post<AccountLinkResponse>(`${this.baseUrl}/oauth/callback`, {
      code,
      state,
      pgUserId
    });
  }
}
